// Bootstrap declarations
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Bringing up the additional content to add to the app modal
import AboutModalCommonNote from "../../components/shared/AboutModalCommonNote"

// Context modules
import { useSharedNavigationFunctions } from "../../shared/NavigationFunctions";

// Demo assets
import headerLogo from "./assets/killabears-logo.png"

const Header = (props) => {

    // Retrieve items from context --------------------------------------------------
    // Navigation functions
    const { 
        handleModalShow, handleModalClose,
        modalShow,
    } = useSharedNavigationFunctions();
    // Retrieve items from context --------------------------------------------------

    return (

    <>

        <header className="container-fluid header">
            
            <div className="d-md-flex justify-content-between align-items-center mt-2 mb-2 mx-5">
                
                <div className="ml-2">
                    <a href="/#" onClick={() => window.open('https://www.killabears.com')}>
                        <img src={headerLogo} height={80} alt="KillaBears" />
                    </a>    
                </div>

                <div className="m-2 headerLogo">
                    Banner Maker (unofficial)
                </div> 

                <div className="mr-2">
                    <a href="/#" onClick={handleModalShow}>What is this?</a>
                </div>

            </div>
 
        </header>

        {/* ABOUT PAGE MODAL  */}
        <Modal className="aboutModal" show={modalShow} onHide={handleModalClose}>
            <Modal.Header>
            <Modal.Title>About this app</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <p>Welcome to the <strong>Killaverse (unofficial) Banner Builder</strong>, the place to bring together your favorite KillaBears & KillaBits and share Killa stories with the rest of the world! #WeLikeTheBears</p>
                    <p>This tool was created by Tchoupi (aka <a href="https://www.twitter.com/toudemoune" target="_blank">@ToudeMoune)</a>.</p>
                    {/* <p>Like this app and want it for your own project? Check our <a href="https://www.lfg-wagmi.xyz/" target="_blank">product page</a> to learn more about cool stuff we like to build!</p> */}
                    <AboutModalCommonNote />
                </div>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
                OK
            </Button>
            </Modal.Footer>
        </Modal>

    </>

    );

}

export default Header;